import { Injectable } from '@angular/core';
import { UsersDetailsCustomersListConfigService, Customer } from 'gung-standard';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarLinerUsersDetailsCustomersListConfigService extends UsersDetailsCustomersListConfigService {

  getItems(): Observable<Customer[]> {
    return super.getItems().pipe(
      map(customers => customers.filter(customer => customer.extra.kus.makulerad === '0'))
    );
  }
}